module.exports = __webpack_public_path__ + "assets/suzhi-silogan-transp.eca4a1e.png";